module.exports = __webpack_public_path__ + "assets/img/83.a04513e1.png";